module.exports = __webpack_public_path__ + "img/service-bg.015461ce.jpg";